import React from 'react'

const SocialProofVideo = () => {
    return (
        <div className="social-proof-video">
            <div className="social-proof-video-in">
                <div className="left">
                    <h1>It was love at first story</h1>
                    <p>“Great plugin and amazing support. I trialed several plugins<br/>
                    that try to accomplish the same thing. None of them did it as<br/>
                    beautifully and as simple as EmbedStories”</p>
                    <p><b>Bertha Jo</b>, CEO at jacole</p>
                </div>
                <div className="right">
                    <img src="img/Group-1646.png"/>
                </div>
            </div>
        </div>
    )
}

export default SocialProofVideo
